import React from 'react';
import PropTypes from 'prop-types';

import VerticalSpacer from 'dashboard/components/VerticalSpacer';
import FormRow from 'dashboard/components/form/FormRow';
import FormField from 'dashboard/components/form/FormField';
import TextField from 'dashboard/components/form/TextField';
import RadioButtons from 'dashboard/components/form/RadioButtons';
import { getFormikErrorProps } from 'shared/helpers/errors';
import { Button, Heading } from 'school-space-client/components';

const css = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    },
    contentWrapper: {
        flexGrow: '1'
    },
    button: theme => ({
        maxWidth: theme.layout.baseline * 14
    }),
    header: {
        textAlign: 'center',
        fontWidth: 'normal',
        paddingBottom: 20
    }
};

const options = [
    {
        value: 'organisation',
        label: 'Organisation'
    },
    {
        value: 'individual',
        label: 'Individual'
    }
];

const VerifyCustomer = ({
    firstName,
    lastName,
    organisation,
    customerType,
    phone,
    errors,
    touched,
    submit,
    setFieldValue
}) => (
    <form>
        <Heading level="3" size="xxx-large" styles={css.header}>
            Welcome to School Space!{' '}
        </Heading>
        <Heading level="2" size="x-large" styles={css.header}>
            Please confirm your details{' '}
        </Heading>
        <FormRow alignCenter>
            <FormField inline width={425}>
                <TextField
                    id="customer-first-name"
                    name="First Name"
                    value={firstName}
                    setValue={value => setFieldValue('firstName', value)}
                    placeholder="Bob"
                    required
                    {...getFormikErrorProps('firstName', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            <FormField inline width={425}>
                <TextField
                    id="customer-last-name"
                    name="Last Name"
                    value={lastName}
                    setValue={value => setFieldValue('lastName', value)}
                    placeholder="Smith"
                    required
                    {...getFormikErrorProps('lastName', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            <FormField inline width={425}>
                <TextField
                    id="customer-phone"
                    name="Mobile Phone Number"
                    value={phone}
                    setValue={value => setFieldValue('phone', value)}
                    placeholder="+447123456789"
                    required
                    {...getFormikErrorProps('phone', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            <FormField inline width={425}>
                <RadioButtons
                    name="organisationtype"
                    label=""
                    value={customerType}
                    options={options}
                    setValue={value => setFieldValue('customerType', value)}
                    required
                />
            </FormField>
        </FormRow>
        {customerType === 'organisation' && (
            <FormRow alignCenter>
                <FormField inline width={425}>
                    <TextField
                        id="customer-organisation"
                        name="Organisation"
                        value={organisation}
                        setValue={value => setFieldValue('organisation', value)}
                        placeholder="Bob Football Limited"
                        required
                        {...getFormikErrorProps('organisation', errors, touched)}
                    />
                </FormField>
            </FormRow>
        )}
        <VerticalSpacer />
        <FormRow alignCenter>
            <Button styles={css.button} state="primary" onClick={submit} disabled={false}>
                Continue
            </Button>
        </FormRow>
    </form>
);

VerifyCustomer.defaultProps = {
    firstName: '',
    lastName: '',
    phone: '',
    customerType: 'organisation',
    organisation: ''
};

VerifyCustomer.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    customerType: PropTypes.string,
    organisation: PropTypes.string,
    phone: PropTypes.string,
    errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    touched: PropTypes.objectOf(PropTypes.bool).isRequired,
    submit: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired
};

export default VerifyCustomer;
